import styled, { css } from "styled-components";
import { Paragraph, Heading } from "../../atoms/Typography/Typography.styles";

interface CardNewsProps {
  colorScheme: string
  withBackground: boolean
}

const getColorFromBrand = (color: string) => {
  const brandColorMap = {
    'warmGrey': 'black',
    'lightGrey': 'black',
    'oliveGreen': 'black',
    'neutralTeal': 'black',
    'warmYellow': 'black',
    'neutralBlack': 'white',
    'warmClay': 'white',
    'warmOrange': 'white',
    'darkGreen': 'white',
    'nightSky': 'white',
  }

  return brandColorMap[color] || 'green'
}

const tagColors = {
  warmGrey: "#CFC6BE",
  lightGrey: "#F8FAF2",
  neutralBlack: "#4B4846",
  warmClay: "#A07D6A",
  neutralTeal: "#B1DEE6",
  warmOrange: "#E5673E",
  oliveGreen: "#B6CFBF",
  darkGreen: "#3F605E",
  warmYellow: "#FCC06D",
  nightSky: "#3B7693",
}

export const CardNews = styled.a<CardNewsProps>`
  width: 100%;
  text-decoration: none;

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, withBackground, colorScheme }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'}!important;
  }
`

export const CardNewsImage = styled.div`
  position: relative;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.rem(8)};

  img {
    object-fit: cover;
    object-position: center;
    transition: transform 0.3s ease-in-out;
    transform: scale(1);
  }

  ${({ theme }) => theme.mediaQuery.lg(`
    &:hover {
      img {
        transform: scale(1.1);  
      }
    }
  `)}
`

export const CardNewsCategories = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.rem(8)};
  position: relative;
`

export const CardNewsCategory = styled.div`
  padding: ${({ theme }) => theme.rem(8, 16)};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.rem(52)};

  ${({ color }) => color && css`
    background-color: ${tagColors[`${color}`] };

    ${Paragraph} {
      color: ${getColorFromBrand(color)}!important;
    }
  `}
`